module.exports = __webpack_public_path__ + "static/media/letsgoo_orange.92cfbb0b.png";